import { Link } from "react-router-dom";
import { brand } from "@/tokens/brandTokens";

// Official Córdoba Crea Futuro logo: color for light backgrounds, white for dark ones.
const SRC = { color: "/brand/ccf-color.webp", blanco: "/brand/ccf-blanco.webp" };

export const Logo = ({ variant = "color", className = "h-7 2xl:h-8" }) => (
  <Link to="/" data-testid={variant === "color" ? "logo-link" : `logo-link-${variant}`} className="flex items-center gap-2 shrink-0 mr-3 select-none" aria-label={`${brand.siteName} — inicio`}>
    <img src={SRC[variant]} alt={brand.siteName} className={`${className} w-auto`} data-testid={`logo-img-${variant}`} />
    <span className="align-middle text-[9px] font-heading font-extrabold px-1.5 py-0.5 rounded-full text-white" style={{ background: "var(--brand-accent)" }}>
      {brand.productName.toUpperCase()}
    </span>
  </Link>
);
